import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.scss"],
})
export class AuthComponent implements OnInit {
  form: UntypedFormGroup;
  isPasswordVisible = false;
  isAuthError = false;

  constructor(private readonly _authService: AuthService, private readonly _router: Router) {}

  async authorize() {
    this.isAuthError = false;

    const emailOrLogin: string = this.form.get("email").value;
    const password: string = this.form.get("password").value;

    const signInPromise = emailOrLogin.includes("@")
      ? this._authService.signIn({ email: emailOrLogin, password })
      : this._authService.signInWithLogin({ login: emailOrLogin, password });

    await signInPromise.then(() => this.navigateToDashboard()).catch(() => this.showAuthError());
  }

  private navigateToDashboard() {
    this._router.navigate([""]);
  }

  private showAuthError() {
    this.isAuthError = true;
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl("", [Validators.required]),
      password: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    });
  }
}
